<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <legend>Merchant Stock Orders</legend>
            <!--Grid row-->
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="From Date:" label-for="input-1">
                        <datepicker size="sm" v-model="fromDate" input-class="form-control form-control-sm" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="To Date:" label-for="input-1">
                        <datepicker v-model="toDate" input-class="form-control form-control-sm" :format="customFormatter"
                            placeholder="Select to date"></datepicker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="Order Reference:" label-for="input-1">
                        <b-form-input size="sm" v-model="merchantReference" input-class="form-control"
                            placeholder="Order Reference"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group label-size="sm" label="Status">
                        <b-form-select size="sm" v-model="statusValue" :options="statusOptions"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <br />
                    <b-button type="button" @click="getStockOrders" pill variant="outline-dark">
                        Retrieve Report
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-table striped hover responsive :items="items" :fields="fields" small>
                        <template #cell(createdOn)="data">
                            {{ data.item.createdOn | formateDate }}
                        </template>
                        <template #cell(items)="data">
                            <div v-for="line in data.item.items" :key="line.reference">
                                <span v-if="line.isDeliveryFee">Delivery fee : R{{ line.totalCost.toFixed(2) }}</span>
                                <span v-else>{{ line.quantity }} x {{ line.productName }} : R{{ line.totalCost.toFixed(2) }}</span>
                            </div>
                        </template>
                        <template #cell(totalAmount)="data">
                            R{{ data.item.totalAmount.toFixed(2) }}
                        </template>
                        <template #cell(fulfilled)="data">
                            <b-badge v-if="data.item.fulfilled" variant="success">
                                Fulfilled {{ data.item.fulfilledOn | formateDate }} by {{ data.item.fulfilledBy }}
                            </b-badge>
                            <b-badge v-else variant="warning">Not fulfilled</b-badge>
                            <div v-if="data.item.notes"><small>{{ data.item.notes }}</small></div>
                        </template>
                        <template #cell(action)="data">
                            <b-button v-if="!data.item.fulfilled" size="sm" pill variant="outline-success"
                                @click="markFulfilled(data.item)">
                                Mark fulfilled
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="Page:" label-for="input-1">
                        <b-form-input size="sm" type="number" v-model.number="selectedPage" @change="handlePageClick"
                            input-class="form-control"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <br />
                    <span>Total records : {{ totalRecords }}</span>
                </b-col>
            </b-row>

            <loading :active.sync="isLoading" :is-full-page="true"></loading>
        </div>
    </main>
</div>
